import { UserService } from './../../../../services/user';
import { Component, OnInit, ViewChild, AfterViewInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import Swal from 'sweetalert2';

import { PointOfSaleService } from '../../../../services/pos';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { WarehouseTypeService } from '../../../../services/warehouse-type';
import { AccountTypeService } from '../../../../services/account-type';

@Component({
  selector: 'app-pointsofsale',
  templateUrl: './pointsofsale.component.html',
  styleUrl: './pointsofsale.component.scss'
})
export class PointsofsaleComponent implements OnInit, AfterViewInit {

  displayedColumns: string[] = [
    "image",
    "name",
    "location",
    "type",
    "created_at",
    "delete"
  ];
  selectedPosDetails: any = null;
  detailsPopup = false;


  dataSource = new MatTableDataSource<any>([]);
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  contentReady = true;
  isLoadingMore = false;
  noData = false;
  page = 1;
  totalPages = 1;
  isMobile = false;
  isAr = localStorage.getItem("language") === "ar";
  userId: any | null = null;
  constructor(
    private router: Router,
    private posService: PointOfSaleService,
    private deviceService: DeviceDetectorService,
    private accountTypeService: AccountTypeService,
    private warehouseTypeService: WarehouseTypeService,
    private UserService: UserService,
  ) { }

  // ===============================
  // INIT
  // ===============================

  ngOnInit(): void {

    this.isMobile = this.deviceService.isMobileDevice();
    this.flowLog('ngOnInit', { isMobile: this.isMobile });

    if (this.isMobile) {
      this.flowLog('redirect mobile');
      this.router.navigateByUrl('/Pospage.mobile');
      return;
    }

    // اول حاجة نجيب account type
    this.accountTypeService.getAccountType().subscribe(() => {
      this.flowLog('account type loaded', {
        superAdmin: this.superAdmin,
        currentAccountType: this.accountTypeService.currentAccountType,
        accessPages: this.accountTypeService.currentAccessPages
      });

      if (this.superAdmin && !this.displayedColumns.includes('total')) {
        this.displayedColumns.splice(
          this.displayedColumns.length - 1,
          0,
          'total'
        );
      }

      this.loadPOS();

    });

  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }
  openDetailsPopup(element: any) {
    this.selectedPosDetails = element;
    this.detailsPopup = true;
  }
  displayValue(value: any): string {
    if (value === null || value === undefined) return '-';
    if (typeof value === 'string' && value.trim() === '') return '-';
    return String(value);
  }

  hasTotalValue(value: any): boolean {
    return Number(value || 0) > 0;
  }

  formatMoney(value: any): string {
    const numberValue = Number(value || 0);

    return numberValue.toLocaleString(this.isAr ? 'ar-EG' : 'en-US', {
      maximumFractionDigits: 2
    });
  }

  closeDetailsPopup() {
    this.detailsPopup = false;
    this.selectedPosDetails = null;
  }

  getPhoneHref(value: any): string | null {
    if (!value) return null;
    return `tel:${value}`;
  }

  getExternalHref(value: any): string | null {
    if (!value || String(value).trim() === '') return null;

    const link = String(value).trim();

    if (link.startsWith('http://') || link.startsWith('https://')) {
      return link;
    }

    return `https://${link}`;
  }

  getPosName(element: any): string {
    if (!element) return '-';

    if (this.isAr) {
      return element.name || element.name_en || '-';
    }

    return element.name_en || element.name || '-';
  }

  warehouseTypeIcon(type: any): string {
    switch (String(type)) {
      case '0':
        return 'fa-solid fa-building';
      case '1':
        return 'fa-solid fa-warehouse';
      case '2':
        return 'fa-solid fa-store';
      case '3':
        return 'fa-solid fa-calendar-days';
      case '4':
        return 'fa-solid fa-house-medical';
      case '5':
        return 'fa-solid fa-truck-fast';
      default:
        return 'fa-solid fa-circle-question';
    }
  }

  // ===============================
  // GETTERS
  // ===============================

  get activePosId(): string | null {
    return localStorage.getItem('posId');
  }

  get isAdmin(): boolean {
    return this.accountTypeService.isAdmin() ||
      this.accountTypeService.isSuperAdmin();
  }

  get superAdmin(): boolean {
    return this.accountTypeService.isSuperAdmin();
  }

  get isSubAdmin(): boolean {
    return this.accountTypeService.isSubAdmin();
  }

  get isblueboxMain(): boolean {
    return this.warehouseTypeService.isBlueBoxMain;
  }

  get hasSingleWarehouse(): boolean {
    return this.dataSource.data.length <= 1;
  }

  get totalGoodsValue(): number {
    return this.dataSource.data.reduce(
      (total, item) => total + Number(item?.total_value || 0),
      0
    );
  }

  // ===============================
  // DATA LOAD
  // ===============================
  getUserId() {
    this.UserService.getUserId().subscribe({
      next: (data) => {
        this.userId = data?.user_id ?? localStorage.getItem('user_id');

        if (!this.userId) {
          this.finishEmptyState();
          return;
        }

        this.getUserwarehouse(this.userId);

      },
      error: () => {
        this.userId = localStorage.getItem('user_id');

        if (!this.userId) {
          this.finishEmptyState();
          return;
        }

        this.getUserwarehouse(this.userId);
      }
    });
  }
  loadPOS() {
    this.contentReady = true;
    this.isLoadingMore = false;
    this.noData = false;
    this.page = 1;
    this.totalPages = 1;
    this.flowLog('loadPOS start', { superAdmin: this.superAdmin });

    if (this.superAdmin) {
      this.getAllWarehouses();
      return;
    }
    else {

      this.getUserId();

    }

  }

  getUserwarehouse(userId: string) {
    this.flowLog('getUserwarehouse start', { userId });
    this.posService.getUserPOS(userId).subscribe({
      next: (data) => {

        this.dataSource.data = data ?? [];
        this.totalPages = 1;
        this.setDefaultActivePos();
        this.contentReady = false;
        this.noData = this.dataSource.data.length === 0;
        this.flowLog('getUserwarehouse success loader hidden', {
          count: this.dataSource.data.length,
          noData: this.noData
        });
      },
      error: (error) => {
        this.contentReady = false;
        this.flowLog('getUserwarehouse error loader hidden', { message: error?.message, status: error?.status });
      }
    });
  }

  getAllWarehouses() {
    this.flowLog('getAllWarehouses start');
    this.posService.getAllPOS(this.page).subscribe({
      next: (res) => {
        this.dataSource.data = res?.data ?? [];
        this.totalPages = res?.last_page ?? 1;
        this.setDefaultActivePos();
        this.contentReady = false;
        this.noData = this.dataSource.data.length === 0;
        this.flowLog('getAllWarehouses success loader hidden', {
          count: this.dataSource.data.length,
          totalPages: this.totalPages,
          noData: this.noData
        });
      },
      error: (error) => {
        this.contentReady = false;
        this.flowLog('getAllWarehouses error loader hidden', { message: error?.message, status: error?.status });
      }
    });
  }

  finishEmptyState(): void {
    this.dataSource.data = [];
    this.noData = true;
    this.contentReady = false;
    this.isLoadingMore = false;
  }

  @HostListener('window:scroll', [])
  onScroll(): void {
    if (!this.superAdmin) return;
    if (this.contentReady || this.isLoadingMore) return;
    if (this.page >= this.totalPages) return;

    const bottomReached =
      window.innerHeight + window.scrollY >=
      document.documentElement.scrollHeight - 120;

    if (!bottomReached) return;

    this.loadMorePOS();
  }

  loadMorePOS(): void {
    this.page++;
    this.isLoadingMore = true;

    this.posService.getAllPOS(this.page).subscribe({
      next: (res) => {
        const newData = res?.data ?? [];

        this.dataSource.data = [...this.dataSource.data, ...newData];
        this.totalPages = res?.last_page ?? this.totalPages;
        this.isLoadingMore = false;
      },
      error: () => {
        this.page--;
        this.isLoadingMore = false;
      }
    });
  }

  // ===============================
  // ACTIONS
  // ===============================

  showProducts(id: string) {
    this.clearCartForWarehouseChange();
    localStorage.setItem('posId', id);
    this.navigateAndReload(['/Home']);
  }

  createOrder(id: string) {
    this.clearCartForWarehouseChange();
    localStorage.setItem('posId', id);
    this.navigateAndReload(['/Addorder']);
  }

  openAppointments(warehouseId: string | number): void {
    this.router.navigate(['/clinic-appointments'], {
      queryParams: { warehouse_id: warehouseId }
    });
  }

  canManageAppointments(element: any): boolean {
    return !this.isSubAdmin && ['2', '3', '4'].includes(String(element?.warehouses_type));
  }

  edit(element: any) {
    this.router.navigate(['/createpos'], { queryParams: this.buildEditQueryParams(element) });
  }

  private buildEditQueryParams(element: any): any {
    const settings = element?.business_setting || element?.businessSetting || element?.settings || {};

    return {
      ...element,
      edit_price: settings?.edit_price ?? element?.edit_price,
      quantityguard: settings?.quantityguard ?? element?.quantityguard
    };
  }

  deleteitem(id: string) {

    Swal.fire({
      title: this.isAr ? "متأكد؟" : "Are You Sure?",
      showCancelButton: true,
      confirmButtonText: this.isAr ? "اه" : "YES",
      cancelButtonText: this.isAr ? "لا" : "NO"
    }).then((result) => {

      if (!result.isConfirmed) return;

      this.contentReady = true;

      this.posService.deletePOS(id).subscribe({
        next: () => {
          if (String(this.activePosId) === String(id)) {
            localStorage.removeItem('posId');
          }

          this.loadPOS();
        },
        error: () => this.contentReady = false
      });
    });
  }

  trackById(index: number, item: any) {
    return item?.id;
  }

  private clearCartForWarehouseChange(): void {
    localStorage.removeItem('cart');
    localStorage.removeItem('cartWarehouseId');
  }

  private navigateAndReload(commands: any[]): void {
    this.router.navigate(commands).then((navigated) => {
      if (navigated) {
        window.location.reload();
      }
    });
  }

  private setDefaultActivePos(): void {
    const rows = this.dataSource.data;

    if (!rows.length) {
      this.flowLog('setDefaultActivePos skipped empty rows');
      return;
    }

    const current = localStorage.getItem('posId');
    const currentExists = rows.some(
      item => String(item?.id) === String(current)
    );

    if (!current || !currentExists) {
      const activeId = rows[0].id;
      localStorage.setItem('posId', String(activeId));
      this.flowLog('setDefaultActivePos changed active id', { activeId, previous: current });
      this.warehouseTypeService.getWarehouseType(Number(activeId)).subscribe();
      return;
    }

    this.flowLog('setDefaultActivePos kept existing active id', { current });
  }

  formatDate(date: string): string {
    if (!date) return '-';

    const d = new Date(date);

    if (isNaN(d.getTime())) return '-';

    const day = d.getDate().toString().padStart(2, '0');
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const year = d.getFullYear().toString().slice(2);
    return `${day}-${month}-${year}`;
  }

  private flowLog(step: string, extra: Record<string, any> = {}): void {}
}
